import { IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import { useTranslation } from 'react-i18next';
import { useColorMode } from '@/app/color-mode';

export function ThemeToggle() {
  const { mode, toggle } = useColorMode();
  const { t } = useTranslation();

  return (
    <Tooltip title={t('common.toggleTheme')}>
      <IconButton onClick={toggle} aria-label={t('common.toggleTheme')} size="small">
        {mode === 'dark' ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
